import 'core-js';
import RainRenderer from "./rain-renderer";
import Raindrops from "./raindrops";
import loadImages from "./image-loader";
import createCanvas from "./create-canvas";
import TweenLite from "gsap";

let dropColor, dropAlpha, textureDrizzleFg;
let videoFg, videoBg;

let textureFg,
    textureFgCtx,
    textureBg,
    textureBgCtx;

let textureBgSize={
    //width: 130,
    //height: 290
    width: 260,
    height: 580
    //width: 1920,
    //height: 1280
};

let textureFgSize={
    width:96,
    height:64
};

let raindrops,
    renderer,
    canvas;

let parallax={x:0,y:0};

function loadTextures(callback){
    loadImages([
        {name:"dropAlpha",src: require("./img/drop-alpha.png")},
        {name:"dropColor",src: require("./img/drop-color.png")},
        {name:"textureDrizzleFg",src: require("./img/texture-fg.png")},

    ]).then((images)=>{
        dropColor = images.dropColor.img;
        textureDrizzleFg = images.textureDrizzleFg.img;
        dropAlpha = images.dropAlpha.img;

        callback(init());
    });
}

export default loadTextures;

function init(){
    // videoFg,
    videoBg = document.querySelector("#philippines-video");
    let canvas=document.querySelector('#container');

    let dpi=window.devicePixelRatio;
    //canvas.width=window.innerWidth;
    //canvas.height=window.innerHeight;
    //canvas.style.width=window.innerWidth+"px";
    //canvas.style.height=window.innerHeight+"px";

    raindrops=new Raindrops(
        canvas.width,
        canvas.height,
        dpi,
        dropAlpha,
        dropColor,
        {
            minR:15,
            maxR:30,
            collisionRadiusIncrease:0.002,
            dropletsRate:1,
            dropletsSize:[2, 4],
            dropletsCleaningRadiusMultiplier: 0.30,
            //minR:10,
            //maxR:20,
            //rainChance:0.15,
            //rainLimit:2,
            //dropletsRate:10,
            //dropletsSize:[3.5,6],
            //
            //raining:true,
            //trailRate:1,
            //trailScaleRange:[0.25,0.35],
            //flashFg:null,
            //flashBg:null,
            //flashChance:0,
            //collisionRadiusIncrease:0.0002
        }
    );


    // textureFg = createCanvas(textureFgSize.width,textureFgSize.height);
    // textureFgCtx = textureFg.getContext('2d');
    textureBg = createCanvas(textureBgSize.width,textureBgSize.height);
    textureBgCtx = textureBg.getContext('2d');
    textureBgCtx.antialias = false;
    textureBgCtx.imageSmoothingEnabled = false;

    generateTextures();

    renderer = new RainRenderer(canvas, raindrops.canvas, textureBg, textureBg, null,{
        brightness: 1.1,
        alphaMultiply: 6,
        alphaSubtract: 3,
        parallaxFg:0
    });

    updateTextures();

    return renderer;
}

function updateTextures(){
    if (renderer && renderer.playing) {
        generateTextures();
        renderer.updateTextures();
    }

    //setTimeout(updateTextures, 1000/100);
    requestAnimationFrame(updateTextures);
}
function generateTextures(){
    const width = 1920;
    const height = 1080;
    const sw = 260;
    const sh = 580;

    const scaleW = window.innerWidth / width;
    const scaleH = window.innerHeight / height;
    const videoSW = sw * scaleW;
    const videoSH = sh * scaleH;

    const sx = (width - videoSW) / 2;
    const sy = (height - videoSH) / 2;

    // textureFgCtx.drawImage(videoBg,
    //     sx, sy,
    //     videoSW, videoSH,
    //     0, 0,
    //     sw, sh
    // );
    textureBgCtx.drawImage(videoBg,
        sx, sy,
        videoSW, videoSH,
        0, 0,
        sw, sh
    );
    //textureBgCtx.drawImage(videoBg,0,0,textureBgSize.width,textureBgSize.height,0,0,textureBgSize.width,textureBgSize.height);
}



// WEBPACK FOOTER //
// ./src/js/screens/Screen3/water/index.js